import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

export default class UserStatusRow extends PureComponent {
  static propTypes = {
    date: PropTypes.string,
    timestamps: PropTypes.array
  };

  getTotalDuration() {
    const timestamps = [...this.props.timestamps];
    timestamps.sort((a, b) => a - b);
    let totalDuration = 0;
    let lastTimeStamp;
    const fiveMinDelta = 5;

    timestamps.forEach(t => {
      if (lastTimeStamp && t < lastTimeStamp + fiveMinDelta) {
        totalDuration += t - (lastTimeStamp + fiveMinDelta);
      } else {
        totalDuration += fiveMinDelta;
      }
      lastTimeStamp = t;
    });
    const duration = moment.duration(totalDuration, 'minutes');
    const hours = duration.hours();
    const hoursPadZero = hours < 10 ? '0' : '';
    const mins = duration.minutes();
    const minsPadZero = mins < 10 ? '0' : '';
    return `${hoursPadZero}${hours} hrs ${minsPadZero}${mins} mins`;
  }

  render() {
    const { timestamps, date } = this.props;
    const day = date.split(' ')[0].toLowerCase();
    const multiplier = 100 / 1440;
    return (
      <div className={`user-chart-row weekday-${day}`}>
        <div className="row-label">{date}</div>
        <div className="row-data">
          {timestamps.map((ts, idx) => (
            <div
              key={idx}
              className="row-data-cell"
              style={{ left: `${multiplier * ts}%` }}
            />
          ))}
        </div>
        <div className="row-stats">{this.getTotalDuration()}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/Users/Dashboard/UserStatusRow.js